import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

//Components
import Layout from '../common/Layout';
import Loading from '../common/Loading';

// Redux
import { useSelector, useDispatch } from 'react-redux';
import { Box, Button } from '@material-ui/core';
import { NewLoanUseStyles } from './styles.style';
import { getAllProperties } from '../../redux/properties/thunks';
import { getAllUsers } from '../../redux/users/thunks';
import { createLoan } from '../../redux/loans/thunks';
import WrapperLoan from '../common/WrapperLoan';
import {
  ArrowForward,
  CheckCircleRounded,
  Close,
  GroupAddRounded,
  HomeWorkRounded,
  TodayRounded,
  VpnKey,
  VpnKeyRounded,
} from '@material-ui/icons';
import SearchInvisible from '../common/SearchInvisible/SearchInvisible';
import { StatusCodeKey } from '../../domain/constants/StatusCode';
import ButtonBarcode from '../common/ButtonBarcode';
import { setCurrent } from '../../redux/renovation/thunk';
import Swal from 'sweetalert2';
import useScan from '../../hooks/useScan';
import { HouseKeyComments } from '../HousekeyComments';
import { RenovationKeyField } from '../../domain/constants/RenovationField';

const NewLoan = () => {
  // HOOKS
  const classes: any = NewLoanUseStyles();
  const navigate = useNavigate();
  const { setDestination } = useScan();

  // STATE
  const [showResume, setShowResume] = useState(false);
  const [selectedProperties, setSelectedProperties] = useState<any>([]);
  const [sending, setSending] = useState(false);
  const initialSteps = {
    user: false,
    property: false,
    keys: false,
    period: false,
    complete: false,
  };
  const initialValuesLoan = {
    country: process.env.REACT_APP_ENV_COUNTRY,
    users_id: '',
    period: '',
  };
  const [steps, setSteps] = useState(initialSteps);
  const [valuesLoan, setValuesLoan] = useState<any>(initialValuesLoan);

  // REDUX
  const dispatch = useDispatch<any>();
  const { users } = useSelector((state: any) => state.users.users);
  const loadingUser = useSelector((state: any) => state.users.loading);
  const { properties, loading: propertiesLoading } = useSelector(
    (state: any) => ({
      properties: state.properties.properties.properties,
      loading: state.properties.loading,
    })
  );
  const renovation = useSelector((state: any) => state.renovation);
  const [openComments, setOpenComments] = useState<any | false>(false);

  useEffect(() => {
    setDestination('act-a-loa', false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const beforeSubmitFilter = (value: string) => {
    const letter =
      value.charAt(0).toLowerCase() === RenovationKeyField.prefix
        ? value.charAt(1)
        : value.charAt(3);
    value = value.replaceAll(letter, '-');
    return value;
  };

  /* buscar usuario */
  const submitFilterUser = async (value: any) => {
    if (value) {
      const isEmail = value.includes('@');
      const isNum = !isNaN(+value);
      const filter = isEmail
        ? `&email=${value}`
        : isNum
        ? `&id=${value}`
        : `&barcode=${beforeSubmitFilter(value)}`;
      await dispatch(getAllUsers({ filter, pagination: {} }))
        .unwrap()
        .then((res: any) => {
          if (res.users && res.users[0]) {
            setValuesLoan({ ...valuesLoan, users_id: res.users[0].id });
            setSteps({ ...steps, user: true });
          } else {
            console.error({
              message: 'User response Error Update:',
              payload: res,
            });
            setValuesLoan({ ...valuesLoan, users_id: '' });
            setSteps({ ...steps, user: false });
          }
        });
    } else {
      setValuesLoan({ ...valuesLoan, users_id: '' });
      setSelectedProperties([]);
      setSteps({ ...steps, user: false, property: false });
    }
  };

  /* buscar información de propiedad por NID */
  const submitFilterProperty = ({
    value,
    removeProperty,
  }: {
    value: string;
    removeProperty?: any;
  }) => {
    const itemAlredyExist = selectedProperties.some(
      (prop: { nid: number }) => prop.nid === parseInt(value, 10)
    );
    if (itemAlredyExist) {
      return;
    }

    if (value) {
      const filter = `&nid=${value}`;
      dispatch(getAllProperties({ filter, pagination: {} }))
        .unwrap()
        .then((res: any) => {
          const property = res.properties[0];
          if (property) {
            const keys = property?.keys?.filter(
              (item: any) => item.status_keys_id === StatusCodeKey.inventario
            );
            const keysAvailable = keys?.map((item: any) => {
              return { ...item, active: false };
            });
            setSelectedProperties([
              ...selectedProperties,
              { ...property, keys: keysAvailable },
            ]);
          }
        });
    } else {
      setSteps({
        ...steps,
        property: false,
        keys: false,
        period: false,
      });

      setSelectedProperties(
        removeProperty
          ? selectedProperties.filter(
              (prop: any) =>
                parseInt(prop.nid, 10) !== parseInt(removeProperty, 10)
            )
          : []
      );
      setShowResume(false);
    }
  };

  /* agregar llaves*/
  const submitkeys = (value: any) => {
    function getKeyByBarcode(keyArray: any, barcode: string) {
      for (let i = 0; i < keyArray.length; i++) {
        const property = keyArray[i];
        const keys = property.keys;
        for (let j = 0; j < keys.length; j++) {
          if (keys[j].barcode === barcode) {
            return { property: property, key: keys[j] };
          }
        }
      }

      return null;
    }

    const key = getKeyByBarcode(selectedProperties, value);

    if (key?.key) {
      const propertiesWithKeysActive = selectedProperties.map((prop: any) => {
        if (prop.nid === key.property.nid) {
          return {
            ...prop,
            keys: prop.keys.map((k: any) => {
              if (k.barcode === value) {
                return {
                  ...k,
                  active: !k.active,
                };
              }
              return k;
            }),
          };
        }
        return prop;
      });
      const hasActiveKeys = propertiesWithKeysActive.every((prop: any) =>
        prop.keys.some((k: any) => k.active)
      );

      setSelectedProperties(propertiesWithKeysActive);
      setSteps({ ...steps, keys: hasActiveKeys });
    } else {
      Swal.fire({
        icon: 'error',
        title: 'La llave escaneada, no corresponde con ninguna disponible',
        text: 'Por favor, intenta de nuevo',
      });
    }
  };

  // agregar el numero de días de prestamo
  const handlePeriod = (days: string) => {
    setValuesLoan({ ...valuesLoan, period: days });
    if (steps.user && steps.property && steps.keys) {
      setSteps({ ...steps, period: true, complete: true });
    } else {
      setSteps({ ...steps, period: true });
    }
  };

  // cancelar
  const handleCancel = () => {
    setSteps(initialSteps);
    setValuesLoan(initialValuesLoan);
    setSelectedProperties([]);
    setShowResume(false);
    setSending(false);
  };

  // continuar de llaves a periodo
  const handleContinue = () => {
    setShowResume(true);
    if (steps.user && steps.property && steps.keys && steps.period) {
      setSteps({ ...steps, complete: true });
    }
  };

  // Finaliza el prestamo
  const handleSendLoan = () => {
    const propertiesWithKeysActive = selectedProperties.map((prop: any) => {
      return {
        nid: prop.nid,
        keys: prop.keys
          .filter((k: any) => k.active)
          .map((key: any) => ({
            id: key.id,
            active: key.active,
            barcode: key.barcode,
            properties_nid: key.properties_nid,
          })),
      };
    });
    const hasActiveKeys = propertiesWithKeysActive.every((prop: any) =>
      prop.keys.some((k: any) => k.active)
    );

    const { users_id, period } = valuesLoan;
    if (users_id && period && hasActiveKeys) {
      if (sending) {
        return;
      }
      setSending(true);
      dispatch(
        createLoan({
          ...valuesLoan,
          properties_with_keys_active: propertiesWithKeysActive,
        })
      )
        .unwrap()
        .then(() => {
          setTimeout(function () {
            navigate(0);
          }, 3000);
        });
    }
  };

  //Código de barras
  useEffect(() => {
    const executeProcess = async () => {
      if (renovation?.actionInProcess) {
        switch (renovation.process.prefix.toLowerCase()) {
          case 'usr':
            submitFilterUser(renovation.process.id);
            break;
          case 'pro':
            submitFilterProperty({ value: renovation.process.id });
            break;
          case RenovationKeyField.prefix:
            submitkeys(renovation.process.barcode);
            break;
          case 'con':
            handleContinue();
            break;
          case 'can':
            handleCancel();
            break;
          case '2 d':
            handlePeriod('2');
            break;
          case '4 d':
            handlePeriod('4');
            break;
          case '6 d':
            handlePeriod('6');
            break;
          case 'fin':
            handleSendLoan();
            break;
        }
        dispatch(
          setCurrent({
            currentView: renovation.currentView,
            url: renovation.url,
            actionInProcess: false,
            process: {},
            title: renovation.title,
          })
        );
      }
    };
    executeProcess();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [renovation?.actionInProcess]);

  //Fin de los filtros
  return (
    <Layout>
      <WrapperLoan>
        <Box
          className='relative'
          sx={{ display: 'flex', justifyContent: 'space-evenly' }}
        >
          <div className={`py-3 px-5 rounded-3xl`}>
            <div
              className={`!mx-auto flex items-center justify-center rounded-full w-16 h-16 ${
                steps.user ? 'bg-green-500' : 'bg-gray-400'
              }`}
            >
              <GroupAddRounded className='!w-11 !h-11 text-white' />
            </div>
            <p className='text-lg mt-0.5 text-center'>Usuario</p>
          </div>
          <div className={`py-3 px-5 rounded-3xl`}>
            <div
              className={`!mx-auto flex items-center justify-center rounded-full w-16 h-16 ${
                steps.property ? 'bg-green-500' : 'bg-gray-400'
              }`}
            >
              <HomeWorkRounded className='!w-11 !h-11 text-white' />
            </div>
            <p className='text-lg mt-0.5 text-center'>Propiedad</p>
          </div>
          <div className={`py-3 px-5 rounded-3xl`}>
            <div
              className={`!mx-auto flex items-center justify-center rounded-full w-16 h-16 ${
                steps.keys ? 'bg-green-500' : 'bg-gray-400'
              }`}
            >
              <VpnKeyRounded className='!w-11 !h-11 text-white' />
            </div>
            <p className='text-lg mt-0.5 text-center'>Llaves</p>
          </div>
          <div className={`py-3 px-5 rounded-3xl`}>
            <div
              className={`!mx-auto flex items-center justify-center rounded-full w-16 h-16 ${
                steps.period ? 'bg-green-500' : 'bg-gray-400'
              }`}
            >
              <TodayRounded className='!w-11 !h-11 text-white' />
            </div>
            <p className='text-lg mt-0.5 text-center'>Periodo</p>
          </div>
          <div className={`py-3 px-5 rounded-3xl`}>
            <div
              className={`!mx-auto flex items-center justify-center rounded-full w-16 h-16 ${
                steps.complete ? 'bg-green-500' : 'bg-gray-400'
              }`}
            >
              <CheckCircleRounded className='!w-11 !h-11 text-white' />
            </div>
            <p className='text-lg mt-0.5 text-center'>Finalizar</p>
          </div>
          <button
            className='bg-gray-100 rounded-full flex items-center justify-center p-1 px-3 absolute -top-10 -right-10'
            onClick={handleCancel}
          >
            <Close className='h-16 w-16 mr-1' />
            <span>Cancelar</span>
          </button>
        </Box>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-evenly',
            gridGap: '16px',
            minHeight: '80px',
          }}
          className={`${showResume ? classes.resume : ''}`}
        >
          <Box>
            {loadingUser && <Loading height='30px' />}

            {!loadingUser && (
              <>
                {steps.user && (
                  <Box>
                    {users.length > 0 ? (
                      <Box className={classes.info}>
                        <p>
                          <b>Usuario: </b> {users[0].name}
                        </p>
                        <p>{users[0].email}</p>
                        {!showResume && (
                          <div
                            className={classes.close}
                            onClick={() => submitFilterUser('')}
                          >
                            <Close />
                          </div>
                        )}
                      </Box>
                    ) : (
                      <div>No hay resultados para el código de usuario</div>
                    )}
                  </Box>
                )}
              </>
            )}
            {propertiesLoading && (
              <div className='my-12'>
                <Loading height='30px' />
              </div>
            )}

            {!propertiesLoading && (
              <>
                <Box>
                  {selectedProperties.map((property: any) => (
                    <Box
                      key={`selectedProperties_${property.nid}`}
                      className={classes.info}
                    >
                      <p>
                        <b>Propiedad NID:</b> {property.nid}
                      </p>
                      <p>{property.address}</p>
                      {!showResume && (
                        <div
                          className={classes.close}
                          onClick={() => {
                            submitFilterProperty({
                              value: '',
                              removeProperty: property.nid,
                            });
                          }}
                        >
                          <Close />
                        </div>
                      )}
                    </Box>
                  ))}
                </Box>
              </>
            )}
            {steps.complete && (
              <Box
                className={classes.info}
                sx={{ color: '#CC4746 !important' }}
              >
                <b>Solicitud por {valuesLoan.period} días</b>
              </Box>
            )}
          </Box>
          {steps.property && (
            <div>
              {selectedProperties.map((property: any) => (
                <div key={`listProperties_${property.nid}`}>
                  <p className='mb-4 text-xl'>
                    <b>Propiedad NID:</b> {property.nid}
                  </p>
                  <div className='flex gap-4 flex-wrap'>
                    {property.keys?.length > 0 ? (
                      property.keys
                        .filter((k: any) => {
                          if (showResume) {
                            return k.active;
                          }
                          return true;
                        })
                        .map((key: any) => (
                          <Box
                            key={`keys_${key.id}`}
                            className={classes.boxButtonsKey}
                          >
                            <Button
                              className={`${classes.buttonkey} ${
                                key.active ? classes.buttonKeyActive : ''
                              }`}
                              variant='outlined'
                              startIcon={<VpnKey />}
                              onClick={() => {
                                if (showResume) {
                                  return;
                                }
                                submitkeys(key.barcode);
                              }}
                            >
                              <span className='barcode'>{key.barcode}</span>
                              <span className='type'>{key.type_keys_str}</span>
                              <span className='description'>
                                {key.status_keys_description}
                              </span>
                            </Button>
                            {key.active && showResume && (
                              <Button
                                variant='contained'
                                onClick={() => setOpenComments(key)}
                                color='secondary'
                              >
                                Comentarios
                              </Button>
                            )}
                          </Box>
                        ))
                    ) : (
                      <Box
                        sx={{
                          fontSize: '20px',
                          p: 4,
                          bgcolor: '#FFDEDE',
                          position: 'relative',
                        }}
                        className='mt-2'
                      >
                        <div
                          className={classes.close}
                          onClick={() =>
                            submitFilterProperty({
                              value: '',
                              removeProperty: property.nid,
                            })
                          }
                        >
                          <Close />
                        </div>
                        {properties.length
                          ? 'No hay llaves disponibles'
                          : 'No existe la propiedad'}
                      </Box>
                    )}
                  </div>
                  <hr className='my-12' />
                </div>
              ))}
            </div>
          )}
        </Box>

        <Box sx={{ display: 'block', position: 'relative', height: '50px' }}>
          {/* seleccionar llaves */}
          {!showResume && (
            <SearchInvisible
              onHandleChange={submitkeys}
              placeholder='Escanea o selecciona el código de las llaves'
            />
          )}

          {/* seleccionar dis de prestamo */}
          {showResume && !steps.period && (
            <SearchInvisible
              onHandleChange={handlePeriod}
              placeholder='Escanea o selecciona los días de préstamo'
            />
          )}
          {/* buscador información propiedad */}
          {!steps.property && (
            <SearchInvisible
              resetValueOnClick
              onHandleChange={(v: string) => submitFilterProperty({ value: v })}
              placeholder='Escanea o digita el código de la propiedad'
              isDisabled={propertiesLoading}
            />
          )}

          {/* buscador información usuario */}
          {!steps.user && (
            <SearchInvisible
              onHandleChange={submitFilterUser}
              placeholder='Escanea o digita el código del usuario'
            />
          )}
          {steps.complete && (
            <Box className={classes.verification}>
              Verifique los datos para finalizar
            </Box>
          )}
        </Box>

        {steps.keys && steps.user && !showResume && (
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'space-evenly',
              gridGap: '16px',
            }}
          >
            <ButtonBarcode
              id=''
              src='/barcodes/cancelar.png'
              onClick={handleCancel}
            />
            <ButtonBarcode
              id=''
              src='/barcodes/continuar.png'
              onClick={handleContinue}
            />
          </Box>
        )}

        {!!selectedProperties.length && steps.user && !steps.property && (
          <div className='mx-auto w-[674px] mt-10 flex items-center justify-center'>
            <button
              onClick={() => {
                setSteps({ ...steps, property: true });
              }}
              disabled={propertiesLoading}
              type='button'
              className='disabled:bg-gray-400 flex items-center justify-center text-white w-56 bg-purple-700 hover:bg-blue-800 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 mr-2 mb-2 darkNot:bg-blue-600 darkNot:hover:bg-blue-700 focus:outline-none darkNot:focus:ring-blue-800'
            >
              Continuar a llaves
              <ArrowForward className='ml-4' />
            </button>
          </div>
        )}
        {!steps.period && showResume && (
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'space-evenly',
              gridGap: '16px',
            }}
          >
            <ButtonBarcode
              id=''
              src='/barcodes/dos-dias.png'
              onClick={() => handlePeriod('2')}
            />
            <ButtonBarcode
              id=''
              src='/barcodes/cuatro-dias.png'
              onClick={() => handlePeriod('4')}
            />
            <ButtonBarcode
              id=''
              src='/barcodes/seis-dias.png'
              onClick={() => handlePeriod('6')}
            />
          </Box>
        )}

        {steps.period && showResume && (
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'space-evenly',
              gridGap: '16px',
            }}
          >
            <ButtonBarcode
              id=''
              src='/barcodes/cancelar.png'
              onClick={handleCancel}
            />
            <ButtonBarcode
              id=''
              src='/barcodes/finalizar.png'
              onClick={handleSendLoan}
            />
            {sending && <Loading height='30px' />}
          </Box>
        )}
      </WrapperLoan>
      {openComments && showResume && (
        <HouseKeyComments
          housekey_id={openComments.id}
          housekey_code={openComments.barcode}
          open
          onClose={() => setOpenComments(false)}
        />
      )}
    </Layout>
  );
};

export default NewLoan;
